var styles = {"control":"styles_control__11--R px1","collapsed":"styles_collapsed__hbtY3","flat":"styles_flat__2F6VP flex items-center justify-center"};

export default styles;
//# sourceMappingURL=styles.css.js.map
